<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M7.5 4.16699H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M2.5 4.16699H4.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M7.5 10H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M2.5 10H4.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M7.5 15.833H17.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M2.5 15.833H4.16667" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
